import Vue from 'vue';
import VueRouter from 'vue-router';

const BaseLayout = () => import('../layouts/BaseLayout.vue');
const ModalLayout = () => import('../layouts/ModalLayout.vue');

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'hash',
	routes: configRoutes(),
});

// Run this whenever a navigation is triggered
router.beforeEach((to, from, next) => {
	// Fetch user roles from local storage
	let user = JSON.parse(localStorage.getItem('user'));
    next();

	// Route requires user to have meta string of 'user' to get access
	if (to.matched.some(record => record.meta.requiresUser)) {
		if (user !== null) {
			next();
		} else {
			localStorage.clear();
			next({
				path: '/login',
				params: { nextUrl: to.fullPath },
			});
		}
	} else {
		next();
	}
});

function configRoutes() {
	return [
		{
			path: '/',
			redirect: '/login',
			name: 'ModalLayout',
			component: ModalLayout,
			children: [
				{
					path: '/login',
					name: 'Login',
					component: () => import('../views/auth/Login.vue'),
				},
				{
					path: '/forgot-password',
					name: 'ForgotPassword',
					component: () => import('../views/ForgotPassword.vue'),
				},
				{
					path: '/reset-password/:token',
					name: 'Reset',
					component: () => import('../views/ResetPassword.vue'),
				},
			],
		},

		{
			path: '/',
			redirect: '/dashboard',
			name: 'BaseLayout',
			component: BaseLayout,
			meta: {
				requiresUser: true,
			},
			children: [
				{
					path: '/dashboard',
					name: 'Dashboard',
					component: () => import('../layouts/DashboardLayout.vue'),
				},
				{
					path: '/search',
					name: 'Search',
					component: () => import('../views/search/Search.vue'),
				},
				{
					path: '/settings',
					name: 'Settings',
					component: () => import('../views/auth/Settings.vue'),
				},
			],
		},

		// Wildcard route
		{
			path: '/:pathMatch(.*)*',
			redirect: '/dashboard',
		},
	];
}

export default router;
